import { intlFormat } from 'date-fns';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentLang } from '@debbie/cortex/dist/lang/selectors';
const formatted = (date, locale, options) => {
    return intlFormat(new Date(date), {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: (options === null || options === void 0 ? void 0 : options.long) ? '2-digit' : undefined,
        minute: (options === null || options === void 0 ? void 0 : options.long) ? '2-digit' : undefined,
    }, {
        locale: locale,
    });
};
const Timestamp = (props) => {
    const currentLang = useSelector(selectCurrentLang);
    const short = useMemo(() => formatted(props.date, currentLang), [props.date, currentLang]);
    const long = useMemo(() => formatted(props.date, currentLang, { long: true }), [props.date, currentLang]);
    return (React.createElement("span", { "data-tooltip-id": "tooltip-bottom", "data-tooltip-content": long }, props.showTime ? long : short));
};
export default Timestamp;
//# sourceMappingURL=Timestamp.js.map